import { render, staticRenderFns } from "./DeleteQuestionDialog.vue?vue&type=template&id=3a8e0c72&scoped=true"
import script from "./DeleteQuestionDialog.vue?vue&type=script&lang=js"
export * from "./DeleteQuestionDialog.vue?vue&type=script&lang=js"
import style0 from "./DeleteQuestionDialog.vue?vue&type=style&index=0&id=3a8e0c72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8e0c72",
  null
  
)

export default component.exports